import {} from "../../syntax/index.js";
import { Keyword } from "../textual/keyword.js";
/**
 * @public
 */
export var Current;
(function (Current) {
    /**
     * {@link https://drafts.csswg.org/css-color/#valdef-color-currentcolor}
     */
    Current.parse = Keyword.parse("currentcolor");
})(Current || (Current = {}));
//# sourceMappingURL=current.js.map